document.addEventListener("DOMContentLoaded", () => {
  const loadMoreButton = document.getElementById("loadMoreArticles");
  const articlesContainer = document.querySelector(".sp-tagged-news__grid");

  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function () {
      articlesContainer.classList.add("loading");
      const blogHandle = loadMoreButton.getAttribute("data-blog");
      const tag = loadMoreButton.getAttribute("data-tag");
      let page = parseInt(loadMoreButton.getAttribute("data-next-page"), 10);

      let url = `/blogs/${blogHandle}/?view=ajax&page=${page}`;
      if (tag) {
        url = `/blogs/${blogHandle}/tagged/${tag}/?view=ajax&page=${page}`;
      }

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          const newArticles = tempDiv.querySelectorAll(".sp-article-card");
          newArticles.forEach((article) => {
            articlesContainer.appendChild(article);
          });

          loadMoreButton.setAttribute("data-next-page", page + 1);

          const hasMoreArticles = tempDiv
            .querySelector("[data-has-more]")
            .getAttribute("data-has-more");
          if (!hasMoreArticles) {
            loadMoreButton.style.display = "none";
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          articlesContainer.classList.remove("loading");
        });
    });
  }
});
